var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeHouse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zc3b8h7wda",
    d: "M0.9 0.748L1.354 0.748 1.354 1.648 0.9 1.648z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ptgivtjc6c",
    d: "M0.155 0.888L4.344 0.888 4.344 18 0.155 18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jj238scd1e",
    d: "M0.296 0.158L0.749 0.158 0.749 1.058 0.296 1.058z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w2u73kz1og",
    d: "M0.13 0.696L4.741 0.696 4.741 3.146 0.13 3.146z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.304)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3rj5xgz9gb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zc3b8h7wda"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M.907 1.2c0-.219-.016.211 0 0",
    mask: "url(#3rj5xgz9gb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M4.811 3.043c-.17-.45-.758-.45-.927 0C3.03 5.316 1.26 10.856.908 18.505c0 3.659 1.1 6.919 2.814 9.053.08.098.123.222.123.353v2.35c0 .3.225.543.502.543s.5-.243.5-.543v-2.349c0-.13.046-.254.125-.353 1.715-2.133 2.815-5.394 2.815-9.054-.353-7.65-2.122-13.189-2.976-15.462M7.787 18.504c.016.212 0-.218 0 0M19.054 23.314c0-.134-.01.128 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.9 12.804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xnpifuyc6d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ptgivtjc6c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M2.532 1.093c-.103-.274-.462-.274-.565 0C1.447 2.477.37 5.851.155 10.509c0 2.23.67 4.214 1.713 5.513.05.06.076.136.076.216v1.431c0 .183.137.331.305.331.168 0 .305-.148.305-.33v-1.43c0-.081.027-.157.076-.217 1.045-1.299 1.714-3.285 1.714-5.514-.215-4.658-1.292-8.03-1.812-9.416",
    mask: "url(#xnpifuyc6d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.5 22.704)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dedj5ck31f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jj238scd1e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M.744.61c.01.128 0-.134 0 0",
    mask: "url(#dedj5ck31f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M16.868 5.282l-.027-.03-.06-.06c-.077-.074-.163-.143-.255-.204-.28-.187-.591-.286-.899-.286l-.03.001c-.168.004-.337.036-.505.096-.089.033-.179.073-.267.122.015-.01.032-.014.05-.014-.043 0-.133.06-.2.113l-.025-.018c-.13-.1-.263-.183-.396-.246-.127-.06-.256-.105-.386-.133-.112-.025-.228-.038-.343-.038h-.02c-.113.002-.226.015-.339.04-.101.023-.204.056-.305.098-.089.037-.179.082-.268.134-.076.045-.153.096-.228.153-.062.046-.124.097-.183.15-.048.042-.094.087-.137.132-.03.031-.06.063-.086.093l-.016.018c-.003.006-.008.01-.01.014-.04.043-.043.112-.008.16.022.03.054.045.087.045.02 0 .041-.006.06-.02.463-.315.898-.475 1.291-.475.783 0 1.143.63 1.158.658.02.036.057.058.095.058h.001c.039 0 .076-.023.096-.06.012-.023.313-.563 1.055-.563.296 0 .626.087.978.259.015.007.03.01.046.01.036 0 .07-.02.091-.053.031-.05.024-.114-.015-.154"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.3 .204)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "teq8ggbq8h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w2u73kz1og"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#36947D",
    d: "M4.67.859L4.637.843C4.61.831 4.582.82 4.559.811c-.097-.038-.2-.067-.306-.086-.325-.06-.647-.027-.933.098l-.028.013c-.154.07-.3.17-.435.293-.07.065-.14.14-.206.22.012-.013.026-.024.042-.031-.04.017-.103.108-.147.185l-.028-.007c-.156-.04-.309-.063-.454-.068-.138-.005-.273.006-.403.032-.113.022-.225.057-.332.104l-.019.008c-.103.047-.204.106-.3.175-.086.062-.17.134-.249.213-.07.07-.138.148-.202.233-.056.072-.11.151-.16.233-.041.069-.082.14-.118.215-.03.058-.057.118-.082.177-.017.042-.034.083-.047.122l-.008.023-.006.016c-.021.057 0 .121.049.152.03.018.066.02.095.006.02-.008.036-.021.049-.04.322-.482.67-.807 1.035-.966.726-.317 1.277.124 1.3.143.031.025.073.032.11.016.036-.017.061-.053.068-.094.003-.027.096-.65.785-.95.275-.12.61-.171.997-.155.016 0 .031-.003.045-.01.034-.014.06-.045.067-.086C4.75.938 4.721.88 4.671.86",
    mask: "url(#teq8ggbq8h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A6354",
    d: "M17.079 30.804H7.612c-.528 0-.955-.463-.955-1.035v-6.697l5.689-5.103 5.688 5.103v6.697c0 .572-.428 1.035-.955 1.035"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeHouse2);
export default __webpack_public_path__ + "static/media/safeHouse2.889d77b46f158b88220c0c9dbd1ca7f2.svg";
export { ForwardRef as ReactComponent };